var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TopRemak"},[_c('header',[_c('div',{staticClass:"leftbox"},[_c('div',{staticClass:"iconbox"},[_c('span',{class:_vm.topmarkObj.font})]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.topmarkObj.topmark)+" ")])]),_c('div',{staticClass:"English"},[_vm._v(" "+_vm._s(_vm.topmarkObj.English))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }